import { Button } from 'antd';
import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import ScrollTop from 'components/ScrollTop';
import { PlaidLink } from 'components/vendor/plaid';
import { UpdatePlaidLocationState } from 'components/vendor/type';
import ErrorImg from 'static/images/icons/fail.png';
import './style.scss';

const UpdatePlaid: React.FC = () => {
    const location = useLocation();
    const locationState = location.state as UpdatePlaidLocationState | null;

    if (!locationState) {
        return <Navigate to=".." replace />;
    }

    return (
        <div className="ach-update-plaid-root">
            <ScrollTop />
            <img className="error-img" src={ErrorImg} alt="" />
            <p className="title">{__('Your bank account information has been changed')}</p>
            <p className="desc">{__('Please re-verify your bank account')}</p>
            <CardButtonWrap className="btn-box">
                <Link to=".." className="w-100">
                    <Button block size="large" className="btn-important">
                        {__('Back')}
                    </Button>
                </Link>
                <PlaidLink
                    btnProps={{
                        type: 'primary',
                        size: 'large'
                    }}
                    className="btn-important"
                    btnText={__('Re-verify')}
                    bankInfo={locationState.selectedBank}
                    token={locationState.token}
                    source={locationState.source}
                    errorInBtn
                />
            </CardButtonWrap>
        </div>
    );
};

export default UpdatePlaid;
